<div class="instruction-view-container">
  @if (isShowCopyButton) {
    <div
      class="copy-icon"
      role="button"
      tabindex="0"
      (click)="copyInstruction()"
    >
      <span nz-icon nzType="copy"></span>
    </div>
  }

  <iframe
    #iframeRef
    width="100%"
    height="100%"
    frameborder="0"
    [srcdoc]="sanitizedInstruction"
  ></iframe>
</div>
